import React, { useEffect, useState } from 'react';
import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import { format } from 'date-fns';

function ViewPhoneNote({
  patId = 0,
  soapId = 0,
  handleClose = () => {},
  handleChange = () => {},
}) {
  const [allData, setAllData] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/notes/ProgressNote/accessPhoneNotePopup',
          {
            patId: patId,
            soapId: soapId,
          },
        );
        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patId, soapId]);

  const handlePhoneNotePrint = async () => {
    try {
      const response = await post('api/notes/ProgressNote/getPhoneNotePrint', {
        patId: patId,
        soapId: soapId,
      });
      if (response.status === 200) {
        const printWindow = window.open(
          response?.data?.file_url,
          '_blank',
          'height=700,width=900',
        );
        if (!printWindow) {
          setUiMessage(
            'war',
            'Popup blocked! Please allow popups for this website.',
          );
          return;
        }

        printWindow.onload = () => {
          printWindow.print();
        };
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="todo-prgrs-note-main-cntainr">
        <div className="todo-prgrs-note-header">
          <span className="name">
            {allData?.patientDetail?.patientFullName}
          </span>
          <span className="chart">
            (# {allData?.patientDetail?.chart_number})
          </span>
          <span className="age"> {allData?.patientDetail?.age} years: </span>
          <span
            className="title bold"
            style={{ color: '#1ab3a2', marginLeft: '100px' }}
          >
            Note
          </span>
          <span
            className="body-header-cross closeViewSoapViewDetailPopup"
            onClick={handleClose}
          >
            x
          </span>
        </div>

        <div className="width100">
          <div className="prgrs-nt-msg-rqst-nt-mn-blk">
            <div className="todo-prgrs-note-top-info">
              <div
                className="todo-prgrs-note-top-info-row fontsize14"
                style={{ display: 'flex' }}
              >
                <div className="note-top-info-col-1">
                  <span className="info-col-1-label" style={{ width: '75px' }}>
                    Added by:
                  </span>
                  <span className="info-col-1-value">
                    {allData?.soapDetail?.addedBy}
                  </span>
                </div>

                <div className="note-top-info-col-2">
                  <span className="info-col-1-value"></span>
                </div>
                <div className="note-top-info-col-2">
                  <span className="info-col-1-label " style={{ width: '82px' }}>
                    Added Date:
                  </span>
                  <span className="info-col-1-value">
                    {allData?.soapDetail?.dateAdded &&
                      format(
                        new Date(allData?.soapDetail?.dateAdded),
                        DEFAULT_DATE_FORMATE,
                      )}
                  </span>
                </div>
              </div>
              <div
                className="todo-prgrs-note-top-info-row"
                style={{ marginTop: '7px' }}
              ></div>
            </div>
          </div>

          <div className="todo-prgrs-note-main-body progress-access-con">
            <div className="todo-prgrs-note-body-row">
              <div className="body-value content-line-break">
                <div className="cntnt-blk prgrs-vw-blk mental therpy-f-u-cnslng">
                  {allData?.therapyMasterData &&
                    allData?.therapyMasterData.length > 0 &&
                    allData?.therapyMasterData.map((item, i) => (
                      <div key={i}>
                        {/* <div className="assmnt-nt-hdng">
                          <span className="">{item[1]}:</span>
                        </div> */}
                        {item[2].map((childItem, i) => (
                          <div key={i}>
                            <div className="assmnt-nt-hdng">
                              <span className=""> {childItem[1]}:</span>
                            </div>
                            <div className="cntnt-blk prgrs-vw-blk">
                              <div className="assmnt-nt-rw">
                                <span className="assmnt-nt-val width100">
                                  {childItem[3]}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="left width100">
              <span className="soap-note-view-Button-col left width100"></span>
            </div>
          </div>
        </div>

        <div
          className="todo-prgrs-note-button-row"
          style={{ minHeight: '23px' }}
        >
          <span
            className="actn-No right clear-right width-unset"
            onClick={handleClose}
          >
            Cancel
          </span>
          <span
            className="actn-yes right clear-right clear-left width-unset"
            onClick={handleChange}
          >
            Change
          </span>
          <span
            className="actn-yes right clear-right clear-left width-unset"
            onClick={handlePhoneNotePrint}
          >
            Print
          </span>
        </div>
      </div>
    </div>
  );
}

export default ViewPhoneNote;
